export const dropdownLabels = ['Relevance', 'Newest', 'Most Popular'];
